import React from 'react';

export const ENV_COLORS = {
  waterSurface: '#5edcd4',
  waterTop: '#4ecdc4',
  waterMid: '#2a8a8a',
  waterDeep: '#1a5a5a',
  waterAbyss: '#0d3d3d',
  rayColor: '#ffffff',
  substrateBase: '#d4b88a',
  substrateLight: '#e8d4b8',
  substrateDark: '#a8906a',
  distantCoral1: '#3a6a7a',
  distantCoral2: '#4a5a7a',
  distantCoral3: '#3a5a6a',
  distantRock: '#2a4a5a',
  midgroundCoral1: '#c86878',
  midgroundCoral2: '#d87868',
  midgroundCoral3: '#b85868',
  midgroundRock1: '#3a5a6a',
  midgroundRock2: '#4a5a5a',
  midgroundArch: '#2a4a5a',
  foregroundRock1: '#3a5a5a',
  foregroundRock2: '#4a5a5a',
  foregroundRock3: '#354a4a',
  foregroundCoral1: '#d87868',
  foregroundCoral2: '#c86878',
  foregroundCoral3: '#b85868',
  foregroundPlant1: '#2d6a4e',
  foregroundPlant2: '#3a7a5e',
  foregroundPlant3: '#256045',
  bubbleColor: '#c8f0f0',
  causticColor: '#ffffff',
  depthHaze1: '#1a4a5a',
  depthHaze2: '#1a5a6a',
};

export const ENV_SHAPES = {
  waterBackground: 'M 0 0 H 600 V 400 H 0 Z',

  waterRays: `
    M -80 200 Q 50 120 180 200 Q 310 280 440 200 Q 570 120 700 200
    M -100 250 Q 30 160 160 250 Q 290 340 420 250 Q 550 160 680 250
  `,

  substrate: `M 0 320 Q 150 315 300 325 Q 450 310 600 320 V 400 H 0 Z`,

  distantRock1: `M 30 250 Q 50 220 80 240 Q 110 260 85 290 Q 60 285 30 250`,
  distantRock2: `M 520 260 Q 540 230 565 245 Q 590 265 565 295 Q 540 290 520 260`,
  distantCoral1: `M 80 240 Q 105 200 120 170 Q 135 190 120 230 Q 105 220 80 240`,
  distantCoral2: `M 220 250 Q 245 210 265 180 Q 280 200 260 240 Q 240 230 220 250`,
  distantCoral3: `M 420 245 Q 445 205 465 175 Q 480 195 460 235 Q 440 225 420 245`,
  distantCoral4: `M 150 230 Q 170 195 185 165 Q 200 185 180 225 Q 160 215 150 230`,

  midgroundArch: `M 180 280 Q 190 180 300 160 Q 310 150 320 160 Q 430 180 440 280 Q 410 260 320 240 Q 230 260 180 280`,
  midgroundRock1: `M 50 300 Q 60 260 85 270 Q 110 290 90 320 Q 70 330 50 300`,
  midgroundRock2: `M 480 300 Q 490 260 515 270 Q 540 290 520 320 Q 500 330 480 300`,
  midgroundCoral1: `M 120 290 Q 110 250 115 215 Q 125 185 140 205 Q 150 225 140 260 Q 130 280 120 290`,
  midgroundCoral2: `M 340 285 Q 330 245 335 210 Q 345 180 360 195 Q 370 215 360 255 Q 350 275 340 285`,
  midgroundCoral3: `M 260 275 Q 250 235 255 200 Q 265 170 280 185 Q 290 205 280 240 Q 270 260 260 275`,

  foregroundRock1: `M 20 340 Q 30 300 55 310 Q 80 330 65 365 Q 50 375 20 370 Z`,
  foregroundRock2: `M 520 340 Q 535 305 560 315 Q 585 335 570 370 Q 555 380 520 375 Z`,
  foregroundRock3: `M 280 350 Q 290 320 310 325 Q 325 340 315 370 Q 305 380 280 380 Z`,
  foregroundCoral1: `M 80 320 Q 70 280 75 245 Q 85 215 100 235 Q 110 260 95 295 Q 85 315 80 320`,
  foregroundCoral2: `M 400 325 Q 390 285 395 250 Q 405 220 420 235 Q 430 260 425 295 Q 415 315 400 325`,
  foregroundCoral3: `M 200 330 Q 195 295 200 260 Q 210 230 225 245 Q 235 265 230 295 Q 220 315 200 330`,

  foregroundPlant1: `M 140 330 Q 135 290 138 250 Q 142 210 140 180 Q 138 150 142 130 Q 145 110 148 100 Q 152 90 150 110 Q 148 130 150 150 Q 152 180 150 210 Q 148 250 150 290 Q 152 330 145 330 Z`,
  foregroundPlant2: `M 460 335 Q 455 295 458 255 Q 462 215 460 185 Q 458 155 462 135 Q 465 115 468 105 Q 472 95 470 115 Q 468 135 470 155 Q 472 185 470 215 Q 468 255 470 295 Q 472 335 465 335 Z`,
  foregroundPlant3: `M 320 340 Q 318 305 320 270 Q 323 235 321 205 Q 319 175 322 155 Q 325 135 327 125 Q 330 115 328 135 Q 326 155 328 175 Q 330 205 328 235 Q 326 270 328 305 Q 330 340 325 340 Z`,

  causticPattern: `
    M 30 100 Q 60 85 90 100 Q 120 115 150 100 Q 180 85 210 100 Q 240 115 270 100 Q 300 85 330 100 Q 360 115 390 100 Q 420 85 450 100 Q 480 115 510 100 Q 540 85 570 100
    M 20 150 Q 50 135 80 150 Q 110 165 140 150 Q 170 135 200 150 Q 230 165 260 150 Q 290 135 320 150 Q 350 165 380 150 Q 410 135 440 150 Q 470 165 500 150 Q 530 135 560 150 Q 590 165 620 150
    M 40 200 Q 70 185 100 200 Q 130 215 160 200 Q 190 185 220 200 Q 250 215 280 200 Q 310 185 340 200 Q 370 215 400 200 Q 430 185 460 200 Q 490 215 520 200 Q 550 185 580 200
  `,

  bubblePath1: 'M 80 400 Q 85 280 90 160 Q 92 80 100 40',
  bubblePath2: 'M 180 400 Q 185 300 190 180 Q 192 100 200 60',
  bubblePath3: 'M 280 400 Q 285 320 290 200 Q 292 120 300 80',
  bubblePath4: 'M 380 400 Q 385 280 390 160 Q 392 80 400 40',
  bubblePath5: 'M 480 400 Q 485 300 490 180 Q 492 100 500 60',
  bubblePath6: 'M 550 400 Q 555 330 560 220 Q 562 140 570 100',
};

export const ENV_DEFS = `
  <defs>
    <linearGradient id="water-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#5edcd4" stop-opacity="0.5" />
      <stop offset="10%" stop-color="#4ecdc4" stop-opacity="0.4" />
      <stop offset="30%" stop-color="#2a8a8a" stop-opacity="0.35" />
      <stop offset="55%" stop-color="#1a5a5a" stop-opacity="0.3" />
      <stop offset="80%" stop-color="#1a4a5a" stop-opacity="0.35" />
      <stop offset="100%" stop-color="#0d3d3d" stop-opacity="0.4" />
    </linearGradient>

    <linearGradient id="substrate-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stop-color="#e8d4b8" />
      <stop offset="40%" stop-color="#d4b88a" />
      <stop offset="70%" stop-color="#b89878" />
      <stop offset="100%" stop-color="#988060" />
    </linearGradient>

    <radialGradient id="bubble-gradient" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.5" />
      <stop offset="40%" stop-color="#c8f0f0" stop-opacity="0.2" />
      <stop offset="100%" stop-color="#8ad0d0" stop-opacity="0" />
    </radialGradient>

    <radialGradient id="caustic-glow" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#ffffff" stop-opacity="0.12" />
      <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
    </radialGradient>

    <radialGradient id="depth-haze-1" cx="50%" cy="80%" r="60%">
      <stop offset="0%" stop-color="#1a4a5a" stop-opacity="0" />
      <stop offset="70%" stop-color="#1a4a5a" stop-opacity="0.15" />
      <stop offset="100%" stop-color="#1a4a5a" stop-opacity="0.3" />
    </radialGradient>

    <radialGradient id="depth-haze-2" cx="50%" cy="100%" r="50%">
      <stop offset="0%" stop-color="#1a5a6a" stop-opacity="0" />
      <stop offset="50%" stop-color="#1a5a6a" stop-opacity="0.1" />
      <stop offset="100%" stop-color="#1a5a6a" stop-opacity="0.25" />
    </radialGradient>

    <filter id="water-blur" x="-10%" y="-10%" width="120%" height="120%">
      <feGaussianBlur stdDeviation="1" />
    </filter>

    <filter id="soft-glow" x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur stdDeviation="3" result="blur" />
      <feMerge>
        <feMergeNode in="blur" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>

    <filter id="distant-blur" x="-10%" y="-10%" width="120%" height="120%">
      <feGaussianBlur stdDeviation="2" />
    </filter>
  </defs>
`;